import { render, staticRenderFns } from "./OnPremiseTableRow.vue?vue&type=template&id=b0b34930&scoped=true&"
import script from "./OnPremiseTableRow.vue?vue&type=script&lang=ts&"
export * from "./OnPremiseTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./OnPremiseTableRow.vue?vue&type=style&index=0&id=b0b34930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b34930",
  null
  
)

export default component.exports